<template>
  <div
    :class="[`rankingItem col-md-4 ${data.defaultGoal >= 100 ? 'concluidaMeta' : (data.defaultGoal < 40 ? 'abaixoMeta' : 'mediaMeta')}`]"
    style="margin: 15px 0px;"
  >
    <div class="col-md-12" style="background-color: #ecf0f1; padding: 15px;">
      <div class="row">
        <div class="col-md-4 d-none d-md-block d-lg-block">
          <img
            v-if="data.image !== null"
            :src="`/storage/${data.image}`"
            alt="Imagem de perfil"
            class="rounded-circle"
            style="width: 110%"
          />
          <img
            v-else
            src="/imgs/default-profile.png"
            alt="Imagem de perfil"
            class="rounded-circle"
            style="width: 110%"
          />
        </div>
        <div class="col-md-8" style="font-size: 12px;">
          <strong>Nome:</strong>
          {{data.name}}
          <br />
          <strong>Ramal:</strong>
          {{data.extension}}
          <br />
          <div v-if="enableCallGoals == 'true'">
            <strong>Meta de Ligações:</strong>
            <div class="progress">
              <div
                :class="[`progress-bar ${data.progressGoalPercentageCalls >= 100 ? 'bg-success' : (data.progressGoalPercentageCalls < 40 ? 'bg-danger' : 'bg-primary')} progress-bar-striped progress-bar-animated`]"
                role="progressbar"
                :style="`width:${data.progressGoalPercentageCalls}%`"
                :aria-valuenow="data.progressGoalPercentageCalls"
                aria-valuemin="0"
                aria-valuemax="100"
              >{{data.progressGoalPercentageCalls}}%</div>
            </div>
            <div v-if="showCallGoalsInfo == 'true'">
              <strong>Meta Inserida:</strong>
              {{data.goalCalls}}
              <br />
              <strong>Concluído:</strong>
              {{data.progressGoalCalls}}
              <br />
            </div>
          </div>
          <div v-if="enableBillingGoals == 'true'">
            <strong>Meta de Faturamento:</strong>
            <div class="progress">
              <div
                :class="[`progress-bar ${data.progressGoalPercentageBilling >= 100 ? 'bg-success' : (data.progressGoalPercentageBilling < 40 ? 'bg-danger' : 'bg-primary')} progress-bar-striped progress-bar-animated`]"
                role="progressbar"
                :style="`width:${data.progressGoalPercentageBilling}%`"
                :aria-valuenow="data.progressGoalPercentageBilling"
                aria-valuemin="0"
                aria-valuemax="100"
              >{{data.progressGoalPercentageBilling}}%</div>
            </div>
            <div v-if="showBillingGoalsInfo == 'true'">
              <strong>Meta Inserida:</strong>
              <span class="mask">{{data.goalBilling}}</span>
              <br />
              <strong>Concluído:</strong>
              <span class="mask">{{data.progressGoalBilling}}</span>
              <br />
            </div>
          </div>

          <div v-if="enablePositivationGoals == 'true'">
            <strong>Meta de Conversão:</strong>
            <div class="progress">
              <div
                :class="[`progress-bar ${data.progressGoalPercentagePositivation >= 100 ? 'bg-success' : (data.progressGoalPercentagePositivation < 40 ? 'bg-danger' : 'bg-primary')} progress-bar-striped progress-bar-animated`]"
                role="progressbar"
                :style="`width:${data.progressGoalPercentagePositivation}%`"
                :aria-valuenow="data.progressGoalPercentagePositivation"
                aria-valuemin="0"
                aria-valuemax="100"
              >{{data.progressGoalPercentagePositivation}}%</div>
            </div>
            <div v-if="showPositivationGoalsInfo == 'true'">
              <strong>Meta Inserida:</strong>
              <span>{{data.goalPositivation}}</span>
              <br />
              <strong>Concluído:</strong>
              <span>{{data.progressGoalPositivation}}</span>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: Object
  },
  data: function() {
    return {
      defaultGoal: process.env.MIX_RANKING_DEFAULT_GOAL,
      enableCallGoals: process.env.MIX_RANKING_ENABLE_CALLS,
      showCallGoalsInfo: process.env.MIX_RANKING_SHOW_CALLS_INFO,
      enableBillingGoals: process.env.MIX_RANKING_ENABLE_BILLING,
      showBillingGoalsInfo: process.env.MIX_RANKING_SHOW_BILLING_INFO,
      enablePositivationGoals: process.env.MIX_RANKING_ENABLE_POSITIVATION,
      showPositivationGoalsInfo: process.env.MIX_RANKING_SHOW_POSITIVATION_INFO,
    };
  },
  mounted() {
    $(".mask")
      .mask("#.##0,00", { reverse: true })
      .trigger("keyup");
  }
};
</script>